/**
 * Created by Administrator on 2017/10/13.
 */
import VueCookie from 'vue-cookie'
import axios from 'axios'
import config from '../../config'

export function getQiniuToken() {
    return VueCookie.get("gys_qiniu_token");
}


// WEBPACK FOOTER //
// ./src/static/js/token.js